import React from "react";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Intro } from "./components/Intro";
import { Breeders } from "./components/Breeders";
import { Kittens } from "./components/Kittens";
import { Adoption } from "./components/Adoption";
import { Breed } from "./components/Breed";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
export function App() {
  return <div className="min-h-screen w-full bg-ink font-sans text-cream" data-id="element-0" data-mp="2rit2p4bc7spw">
      <Navbar data-id="element-1" data-mp="2mn59mdtqiff4" />
      <main data-id="element-2" data-mp="2mnng03a42a0r">
        <Hero data-id="element-3" data-mp="2mjpyfm36lqiz" />
        <Intro data-id="element-4" data-mp="31aqf2ee30qq7" />
        <Breeders data-id="element-5" data-mp="31b8l22qjqjbb" />
        <Kittens data-id="element-6" data-mp="31bs0ncsq4vm6" />
        <Adoption data-id="element-7" data-mp="31c9tdzg6grpc" />
        <Breed data-id="element-8" data-mp="31ctf7r8y808n" />
        <Contact data-id="element-9" data-mp="2wk0b95lb0vxm" />
      </main>
      <Footer data-id="element-10" data-mp="2wjqft2hhpwkj" />
    </div>;
}